import { getLocaleText } from '@/utils/utils';
import { Toast } from 'antd-mobile';
import { useEffect, useState } from 'react';

import loding from '../../../assets/images/order/loding.png';
import styles from './index.less';

// import  from '../DownloadQR';

const LodingModel = (props: any) => {
  const {} = props;

  useEffect(() => {}, []);

  // 获取参数

  return (
    <div className={styles.model}>
      <div className={styles.center}>
        <img src={loding} alt="" className={styles.spin} />
        {getLocaleText('order.page.ordering')}…
      </div>
    </div>
  );
};

export default LodingModel;
